module.exports = __webpack_public_path__ + "static/media/cert_52.292021da.jpg";